module.exports = __webpack_public_path__ + "static/2-64bd9814578f18a63b02a6aa511da549.png";